import React, {useEffect, useState} from "react";
import "./Admin.css"; // Import styles
import { Link,useNavigate } from "react-router-dom"; // ✅ Import Link
import { FaUserCircle } from "react-icons/fa";

import api, { API_ENDPOINTS } from "../config"; // Import API endpoints


const Sidebar = () => {

    const [showLogout, setShowLogout] = useState(false); // State to toggle logout button
      const navigate = useNavigate();
      const [isSuperAdmin, setIsSuperAdmin] = useState(false); // State to check if user is superAdmin

      useEffect(() => {
        const role = localStorage.getItem("role");
        if (role === "SuperAdmin") {
           setIsSuperAdmin(true);
        }}, []);
 

  const handleLogout = async () => {
    try {
     
      const response = await api.get(API_ENDPOINTS.Logout, {}, {
   
      });

      if (response.status === 200) {
        localStorage.removeItem("token");
   
        // Redirect to the login page
        // navigate("/login");
         window.location.href = "/login";
      } else {

      }
    } catch (error) {
      console.error("Error during logout:", error);
     
    }
  };

   return (
    <div>
     
      {/* Sidebar */}
      <div className="sidebar">
        <h2>Admin Panel</h2>
        <ul>
          <Link to="/AdminDashboard">
            <li>Dashboard</li>
          </Link>
          <Link to="/AdminPackages">
            <li>Packages</li>
          </Link>
          <Link to="/Adminservices">
            <li>Services</li>
          </Link>
          <Link to="/AdminsubServices">
            <li>Sub Services</li>
          </Link>
          <Link to="/Orders">
            <li>Orders</li>
          </Link>
          {isSuperAdmin && (
            <Link to="/AddAdmin">
              <li>Add Admin</li>
            </Link>
          )}
        </ul>

         <div className="logout-section">
          <FaUserCircle size={30} />
          <button onClick={handleLogout} className="logout-button">Logout</button>
        </div>
      </div>
      
    </div>
  );
};

export default Sidebar;
